import type { ReactNode } from 'react'

export interface PageHeaderProps {
  /** Gold micro-caps section label, e.g. CONNECTIONS. */
  section: string
  title: string
  action?: ReactNode
  children?: ReactNode
}

/** Page header: gold micro-caps section label + Georgia-serif heading + optional action. */
export function PageHeader({ section, title, action, children }: PageHeaderProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4">
      <div>
        <p className="text-[10px] font-semibold uppercase tracking-widest text-ostrel-gold">{section}</p>
        <h1 className="mt-1 font-display text-3xl text-ostrel-ink">{title}</h1>
        {children}
      </div>
      {action && <div className="flex items-center gap-2">{action}</div>}
    </div>
  )
}
